import { render, staticRenderFns } from "./MasterAbsenceReports.vue?vue&type=template&id=66695228"
import script from "./MasterAbsenceReports.vue?vue&type=script&lang=js"
export * from "./MasterAbsenceReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports